import { Rs } from "constants/common";
import { Container, Typography, Button } from "@cleartrip/ct-design-components";
import Image from "next/image";
import Tick from "icons/checkTick.svg";
import { FunctionComponent, useState } from "react";
import classNames from "classnames";
import CFNRKnowMore from "./cfnrknowMore";
import { sendBusUIAction } from "src/analytics/useAnalytics";
import { CFNR_PROPS } from "./types";

const CFNR: FunctionComponent<CFNR_PROPS> = (props) => {
  const {
    handleAdd,
    selected,
    description,
    loading,
    knowMore,
    titleLogo,
    priceForCFNR,
    poweredBy,
    addBackground = false,
    showingAsBanner = false,
    height,
    width,
    minimumBookingValue,
    cancelDuration,
  } = props;

  const wrapperClassNames = classNames({
    "ba-solid bc-line-500 px-4 br-12 py-3": handleAdd,
    "bc-neutral-100 px-4 br-12 py-3": addBackground,
  });

  const titleWrapperClass = classNames({
    "flex flex-between": !showingAsBanner,
  });

  const classToEnablePoweredBy = classNames({
    "flex flex-between": showingAsBanner,
  });

  const [openKnowMore, setOpenKnowMore] = useState(false);

  const handleKnowMoreClick = () => {
    if (knowMore?.link) {
      window.open(knowMore.link, "_blank");
    } else {
      setOpenKnowMore(true),
        sendBusUIAction({ actionName: "know_more_clicked" });
    }
  };
  return (
    <Container
      backgroundColor={addBackground ? "#EEE9F9" : ""}
      className={wrapperClassNames}
    >
      <Container className={titleWrapperClass}>
        <Container>
          <Container className={classToEnablePoweredBy}>
            {titleLogo ? (
              <Image
                src={titleLogo}
                height={height ? height : 32}
                width={width ? width : 98}
                alt="CFNR_LOGO"
              />
            ) : null}
            {poweredBy ? (
              <Container className="flex flex-middle h-6">
                <Typography variant="B4" color="subheading">
                  {poweredBy.text}
                </Typography>
                <Image
                  className="ml-1"
                  width={50}
                  height={10}
                  src={poweredBy.logo}
                  alt="poweredby"
                  fetchPriority="high"
                />
              </Container>
            ) : null}
          </Container>

          <Container className="flex mt-2">
            <Typography
              className="flex"
              variant={addBackground ? "P2" : "B1"}
              dangerouslySetInnerHTML={{ __html: description }}
            />
            {knowMore ? (
              <>
                <Typography
                  className="ml-1 td-none "
                  isClickable
                  variant="L1"
                  color="link"
                  onClick={handleKnowMoreClick}
                >
                  {knowMore.text}
                </Typography>
              </>
            ) : null}
          </Container>
        </Container>
        {handleAdd ? (
          <Container className="flex">
            <Typography className="mr-4" variant="HM3">
              {Rs}
              {priceForCFNR}
            </Typography>

            <Button
              onClick={() => handleAdd("CFNR")}
              variant={selected ? "contained" : "outline"}
              LeftIcon={<Tick />}
              showLeftIcon={!loading && selected}
              minWidth="104px"
              loading={loading}
              styleConfig={{
                typography: {
                  className: selected ? "ml-2" : "",
                },
              }}
            >
              {selected ? "Added" : "Add"}
            </Button>
          </Container>
        ) : null}
      </Container>

      <CFNRKnowMore
        cancelDuration={cancelDuration}
        minimumBookingValue={minimumBookingValue}
        open={openKnowMore}
        onClose={() => setOpenKnowMore(false)}
      />
    </Container>
  );
};

export default CFNR;
